<template>  
  <v-card flat>
    <v-icon
      class="close"
      @click.prevent="$emit('close')"
      >$sl-close</v-icon
    >
    <h2>{{ $t("company.link-apprentice") }}</h2>
    <!--  used to display instructor list -->
    <v-list v-if="apprenticeList && apprenticeList.length > 0" class="instructor mt-4" flat>
      <v-list-item-group v-model="selectedApprentices" :multiple="true" :mandatory="false">
        <template v-for="(item, index) in apprenticeList">
          <v-list-item
            :disabled="item.isDisabled"              
            v-if="item && item.id"
            :key="item.id"
            :value="item.id"
          >
            <v-list-item-icon>
              <v-icon>$sl-apprentice</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ml-4">
              <v-list-item-title>{{ item.apprentice.firstName }} {{ item.apprentice.lastName }}</v-list-item-title>
              <!-- <v-list-item-subtitle>{{ $tc('labels.apprentice-count', item.numApprentices) }}</v-list-item-subtitle> -->
              <v-list-item-subtitle v-if="item.profession && item.profession.name">{{ item.profession.name }}</v-list-item-subtitle> 
            </v-list-item-content> 
            <v-list-item-icon>
              <v-checkbox v-model="selectedApprentices" @click.native="check($event)" :value="item.id" ></v-checkbox>
            </v-list-item-icon>
          </v-list-item>
          <v-divider :key="`divider-${index}`" v-if="index + 1 < apprenticeList.length"></v-divider>
        </template>
      </v-list-item-group>
      <!-- Used to list instructor  -->
      <ActionButton class="mt-4" @click="linkApprentice" actionIcon="$sl-link">{{ $t('labels.link') }}</ActionButton>
    </v-list>
  </v-card>  
</template>

<script>
import API from '@/services/api.js'
import ActionButton from '@/components/Common/ActionButton'
import {InstructorAbilities} from '@/components/mixins'
import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import {mapActions, mapGetters} from 'vuex'
import {CompanyRoles} from '@/components/mixins'

// @group Company
export default {
  name: 'LinkApprenticeModal',

  mixins: [InstructorAbilities, CompanyRoles],

  props: {
    // Should dialog be showed
    show: false,
    // modal title
  
    // save modal button
    savebtn: {
      // `String`
      type: String,
      // The default value is: `function returning a string`
      default: function () {
        return this.$t('labels.link')
      }
    },
    // cancel modal button
    cancelBtn: {
      // `String`
      type: String,
      // The default value is: `function returning a string`
      default: function () {
        return this.$t('labels.cancel')
      }
    },
    //icon
    icon: {      
      type: String,
      // cancel modal button
      default: '$sl-link'
    },    
    companyId: {      
      type: Number,      
      default: null
    },        
    // Instructors array
    linkedApprentices: {
      // `Array`
      type: Array,      
      default: []
    },
    //Selected instructor
    employee: {      
      type: Object,      
      default: {}
    },
  },

  data: () => ({    
    apprentices: [],
    selectedApprentices: []    
  }),

  components: {
    ActionButton
  },

  computed: {
    ...mapGetters('basic', ['getProfessionById', 'hasProfessionOrientations']),
    ...mapGetters('currentuser', [
      'currentUser',
      'isCompanyUser',
      'isApprentice',
      'isAdminUser',
      'isAdministrator',
      'isDepartmentAdministrator',
      'isCompanyEducationResponsible',
      'isAdmin'
    ]),
    
    /**
     * @vuese
     * Used to list instructors that have a certificate for a specific profession and no more than 3 apprenticenships
     */
    maxApp() {
      return 3
    },

    apprenticeList() {            
      for (var i = 0; i < this.apprentices.length; i++) {
        let machineIds = []
        if(this.apprentices[i].education && this.apprentices[i].education.educationProfessionOrientations && this.apprentices[i].education.educationProfessionOrientations.length>0)
        {
          machineIds = this.apprentices[i].education.educationProfessionOrientations.map(m => m.id)
        }
  
        let haveCert = this.haveCertificates(
              this.employee,
              this.apprentices[i].profession.id,
              machineIds, 
                (this.apprentices[i].type == 'QualificationTime') ? false : true
              )
          let haveMoreThanOneInstr = true
          //An apprentice must have at least 1 instructor. Disabled all the apprentices with only one instructor
          if(this.selectedApprentices.find(f => this.apprentices[i].id))
          {            
            if(this.apprentices[i].instructors && this.apprentices[i].instructors.length==1)
            {
              if(this.apprentices[i].instructors.find(inst=> inst.id==this.employee.id))
              {
                haveMoreThanOneInstr = false
              }
            }            
          }                   
          this.apprentices[i].isDisabled=Boolean(!(haveCert && haveMoreThanOneInstr))
        }

      return this.apprentices      
    }
  },

  created() {
    this.init()
  },

  watch: {    
    /**
     * @vuese
     * Used to watch companyId prop and call init function
     */
    companyId() {
      this.init()
    },    
  },

  methods: {
    
    init() { 
      let id = null
      this.companyId != null ? (id = this.companyId) : (id = this.$route.params.id)

      if (this.linkedApprentices && id) {
      this.selectedApprentices = this.linkedApprentices.map(o => o.id)
        
        let options = { search: '', workplaceId: null, type: 'apprentice' };
        API.listEmployments(Number(id), options)
          .then(res => {
            this.apprentices = res.data
          })
          .catch(err => {
            console.log(err)
          })
      }
    },    
    /**
     * @vuese
     * Used to link apprentice
     */
    linkApprentice() {
      let i = []      
      if(this.selectedApprentices.length>this.maxApp)
      {
        if(this.maxApp == 3)
          this.$events.fire("showError", this.$t("errors.linked-too-many-apprentices-848"));
         else
           this.$events.fire("showError", (this.employee.firstName || '')  + ' ' + (this.employee.lastName || '') + " " + this.$tc("errors.linked-too-many-apprentices", 3));
        return
      }
  
      this.apprentices.forEach(a => {
        this.selectedApprentices.forEach(sa => {
          if (sa == a.id) {
            i.push(a)
          }
        })
      })
      //Fire linked event
      //@arg The argument is object representing apprentices
      
      this.$emit('linked', {apprentices: i, ids: this.selectedApprentices})            
    },
    check: function (e) {
      e.cancelBubble = true;
    },
  }
}
</script>
